module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Zaznaczanie wielu",
      "error": _vm.errors['multiple']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form['multiple']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'multiple', $$v)
      },
      expression: "form['multiple']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opcje do wyboru",
      "required": ""
    }
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.choices), function(choice, index) {
    return _c('div', [_c('div', {
      staticClass: "formset__header"
    }, [_c('span', [_c('el-form-item', {
      attrs: {
        "label": "",
        "error": _vm.errors.choices && _vm.errors.choices[index][_vm.addLanguageSuffix('label')],
        "required": ""
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Nazwa opcji"
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (choice[_vm.addLanguageSuffix('label')]),
        callback: function($$v) {
          _vm.$set(choice, _vm.addLanguageSuffix('label'), $$v)
        },
        expression: "choice[addLanguageSuffix('label')]"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "formset__header__buttons"
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "title": "Usuń element"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeChoice(choice)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])], 1)])])
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addChoice
    }
  }, [_vm._v("\n            Dodaj opcję\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-131df9c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/forms/ChoiceField.vue
// module id = 714
// module chunks = 0